import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import '../../queries/get-place-predictions.js';
import { GET_PLACE_DETAILS } from '../../queries/get-place-details.js';
import { fromQueryPlaceDetailsToPlaceDetails } from './adapters/fromQueryPlaceDetailsToPlaceDetails.js';

const usePlaceDetails = ()=>{
    const [query, queryState] = useLazyQuery(GET_PLACE_DETAILS);
    const data = React.useMemo(()=>{
        var ref;
        return fromQueryPlaceDetailsToPlaceDetails((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.placeDetailsById);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { usePlaceDetails };
//# sourceMappingURL=use-place-details.js.map
